import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
    template: require('./confirm-dialog.component.html'),
    //styles: [require('./confirm-dialog.component.css')]
})
export class ConfirmDialogComponent implements OnInit {
    question: string;
    confirmButtonLabel: string;
    cancelButtonLabel: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>) { }

    ngOnInit() {
        this.confirmButtonLabel = this.confirmButtonLabel || "CONFIRM";
        this.cancelButtonLabel = this.cancelButtonLabel || "CANCEL";
    }

    actionConfirmed() {
        this.dialogRef.close(true);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/confirm-dialog/confirm-dialog.component.ts